import { render, staticRenderFns } from "./InvoiceModal.vue?vue&type=template&id=753c4a20&"
import script from "./InvoiceModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports